import React, { useState } from 'react';
import { submitOnboarding } from '../api/api';
import useAuth from '../hooks/useAuth'; // Assurez-vous d'importer votre hook d'auth pour mettre à jour l'utilisateur si besoin

const OnboardingModal = ({ onComplete }) => {
    const [formData, setFormData] = useState({
        current_tjm: '',
        final_client: '',
        current_poste: '',
        esn_name: ''
    });
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        
        if (!formData.current_tjm || !formData.final_client || !formData.current_poste) {
            setError("Veuillez remplir les champs obligatoires.");
            return;
        }

        setLoading(true);
        try {
            // On récupère la réponse qui contient le nouveau token
            const response = await submitOnboarding(formData);
            
            // --- CORRECTIF : Mise à jour du token ---
            if (response.data && response.data.access_token) {
                localStorage.setItem('token', response.data.access_token);
            }

            if (onComplete) onComplete();
            
            // Maintenant on peut recharger, le nouveau token sera utilisé (is_onboarded: true)
            window.location.reload(); 
        } catch (err) {
            console.error(err);
            setError("Une erreur est survenue lors de l'enregistrement.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{
            position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.85)', zIndex: 9999,
            display: 'flex', justifyContent: 'center', alignItems: 'center'
        }}>
            <div style={{
                backgroundColor: 'white', padding: '30px', borderRadius: '12px',
                width: '100%', maxWidth: '500px', boxShadow: '0 10px 25px rgba(0,0,0,0.2)'
            }}>
                <h2 style={{color: '#2c3e50', marginBottom: '15px'}}>Bienvenue ! 👋</h2>
                <p style={{marginBottom: '20px', color: '#7f8c8d'}}>
                    Pour finaliser la configuration de votre espace, nous avons besoin de quelques informations sur votre mission actuelle.
                </p>

                {error && <div style={{color: 'red', marginBottom: '15px', fontSize: '0.9rem'}}>{error}</div>}

                <form onSubmit={handleSubmit}>
                    <div style={{marginBottom: '15px'}}>
                        <label style={{display:'block', marginBottom:'5px', fontWeight:'bold'}}>Poste / Intitulé de mission *</label>
                        <input 
                            type="text" 
                            value={formData.current_poste}
                            onChange={e => setFormData({...formData, current_poste: e.target.value})}
                            placeholder="Ex: Développeur Fullstack, Tech Lead..."
                            style={{width:'100%', padding:'10px', borderRadius:'6px', border:'1px solid #ccc'}}
                        />
                    </div>

                    <div style={{marginBottom: '15px'}}>
                        <label style={{display:'block', marginBottom:'5px', fontWeight:'bold'}}>Client Final *</label>
                        <input 
                            type="text" 
                            value={formData.final_client}
                            onChange={e => setFormData({...formData, final_client: e.target.value})}
                            placeholder="Ex: BNP, Total, AXA..."
                            style={{width:'100%', padding:'10px', borderRadius:'6px', border:'1px solid #ccc'}}
                        />
                    </div>

                    <div style={{marginBottom: '15px'}}>
                        <label style={{display:'block', marginBottom:'5px', fontWeight:'bold'}}>TJM actuel (€) *</label>
                        <input 
                            type="number" 
                            value={formData.current_tjm}
                            onChange={e => setFormData({...formData, current_tjm: e.target.value})}
                            placeholder="Ex: 500"
                            style={{width:'100%', padding:'10px', borderRadius:'6px', border:'1px solid #ccc'}}
                        />
                    </div>

                    <div style={{marginBottom: '25px'}}>
                        <label style={{display:'block', marginBottom:'5px', fontWeight:'bold'}}>ESN / Intermédiaire (Si applicable)</label>
                        <input 
                            type="text" 
                            value={formData.esn_name}
                            onChange={e => setFormData({...formData, esn_name: e.target.value})}
                            placeholder="Nom de l'ESN si sous-traitance"
                            style={{width:'100%', padding:'10px', borderRadius:'6px', border:'1px solid #ccc'}}
                        />
                    </div>

                    <button 
                        type="submit" 
                        disabled={loading}
                        style={{
                            width: '100%', padding: '12px', backgroundColor: '#3498db', 
                            color: 'white', border: 'none', borderRadius: '6px', 
                            fontSize: '1rem', fontWeight: 'bold', cursor: loading ? 'not-allowed' : 'pointer'
                        }}
                    >
                        {loading ? 'Enregistrement...' : 'Valider et Accéder à mon espace'}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default OnboardingModal;